import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-btn-primary-red',
  templateUrl: './btn-primary-red.component.html',
  styleUrls: ['./btn-primary-red.component.scss'],
})
export class BtnPrimaryRedComponent {
  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnLabel: string;
  @Input() isDisabled: string;
  @Input() routingUrl: string;

  onBtnClick(): boolean {
    if (this.isDisabled === 'true') {
      return false;
    }
    this.callOnClick.emit();
    return true;
  }
}
